import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CatDrawer } from "blocks-nextjs/blocks-react/components/Drawer";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconArrowBack } from "blocks-nextjs/blocks-react/components/Icons/ArrowBack";
import React, { useEffect, useState } from "react";
import AssetPageDetail from "../../pages/Projects/AssetPageDetail";
import useProjectDetailsStore from "../../store/useProjectDetailsStore";
const AssetDetailDrawer = ({ assetDrawerActive, onAssetSelect, setAssetDrawerActive }) => {
    const { assetDetails } = useProjectDetailsStore((state) => ({
        assetDetails: state.assetDetails,
        projectName: state.projectDetails?.projectName
    }));
    const [showGenerateLink, setShowGenerateLink] = useState(false);
    const [isRefreshComponent, setIsRefreshComponent] = useState(assetDrawerActive);
    const handleGenerateLinkStateChange = (isGenerateLink) => {
        setShowGenerateLink(isGenerateLink);
    };
    const handleBackClick = () => {
        setShowGenerateLink(false);
    };
    useEffect(() => {
        setIsRefreshComponent(assetDrawerActive);
        // Reset showGenerateLink when drawer closes
        if (!assetDrawerActive) {
            setShowGenerateLink(false);
        }
    }, [assetDrawerActive]);
    return (_jsx(CatDrawer, { disableBackdropClick: false, disableEscClick: true, hasBackdrop: true, isActive: assetDrawerActive, onBlDrawerClose: () => {
            setAssetDrawerActive(false);
            onAssetSelect(assetDetails);
        }, onBlDrawerOpen: () => { }, preserveContent: false, width: "60%", children: _jsxs(_Fragment, { children: [_jsx("div", { "data-test": "asset-details-drawer-header", slot: "header", children: _jsx(CatHeading, { "data-test": "asset-details-drawer-title", level: "h1", variant: "title", children: showGenerateLink ? (_jsxs("button", { className: "flex items-center gap-2 cursor-pointer hover:opacity-80", onClick: handleBackClick, type: "button", children: [_jsx(CatIconArrowBack, { className: "w-5 h-5 mt-1" }), _jsx("span", { children: "Back" })] })) : ("Asset Details") }) }), _jsx(AssetPageDetail, { isDrawerActive: assetDrawerActive, isRefreshComponent: isRefreshComponent, onGenerateLinkStateChange: handleGenerateLinkStateChange, showGenerateLink: showGenerateLink })] }) }));
};
export default AssetDetailDrawer;
